import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { Calendar } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function PilatesYogaClassesPage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Aulas"
      description="Gerencie a programação de aulas do estúdio."
      icon={Calendar}
    />
  
    </MainLayout>);
}

